export class wager {
  RaceId: number;
  PoolId: number;
  BaseAmount: any;
  Modifier: any;
  Legs: any[];
  Bets: number;
  Surcharge: number;
  Total: number;
  Quick: boolean;
  Only: boolean;
  Fractional: number;
  Condition: any;
  MaxWagerTotal: any;
  Error: string | any;

  constructor(
    RaceId: number,
    PoolId: number,
    BaseAmount: number,
    Modifier: string | undefined,
    Legs: any[],
    Bets: number | any,
    MaxWagerTotal: any,
    Surcharge?: number | any,
    Total?: number | any,
    Quick?: boolean | any,
    Only?: boolean | any,
    Fractional?: number | any,
    Condition?: any | any
  ) {
    this.RaceId = RaceId;
    this.PoolId = PoolId;
    this.BaseAmount = BaseAmount;
    this.Modifier = Modifier;
    this.Legs = Legs;
    this.Bets = Bets;
    this.Surcharge = Surcharge;
    this.Total = Total;
    this.Quick = Quick;
    this.Only = Only;
    this.Fractional = Fractional;
    this.Condition = Condition;
    this.MaxWagerTotal = MaxWagerTotal;
    this.Error = Error;
  }

  getRunnerList(): any[] {
    const runnerArray: any[] = [];
    this.Legs.forEach(leg => {
        runnerArray.push(leg.getRunnerArray());
    });
    return runnerArray;
  }

  ConditionMTPToString(): string {
    if (!this.Condition || !this.Condition.MTPCondition || !this.Condition.MTPOperator) return '';
    let condString = 'MTP ';
    condString += this.Condition.MTPOperator === '-1' ? '< ' : this.Condition.MTPOperator === '0' ? '= ' : '> ';
    condString += this.Condition.MTPCondition;
    return condString;
  }

  ConditionToString(runner: string): string {
    if (!this.Condition || !this.Condition.Conditions) return 'add';
    let condString = '';
    Object.entries(this.Condition.Conditions[runner] || {}).forEach(([key, value]: [string, any]) => {
        condString += `${key}|`;
        value.forEach((v: any, index: number) => {
            condString += v.RunnerId;
            if (index !== value.length - 1) condString += '/';
            else {
                condString += '|odds';
                condString += v.Operator === '-1' ? '<' : v.Operator === '0' ? '=' : '>';
                condString += v.Fraction || v.RequestedValue;
            }
        });
    });
    return condString || 'add';
  }

  calcAmount(): number {
    this.Total = ((this.Bets * 100) * (this.BaseAmount * 100)) / 10000;
    return this.Total;
  }

  getWagerString(): string[] {
    const stringArray: string[] = [this.BaseAmount.toString(), this.PoolId.toString(), ''];
    stringArray[2] = this.Legs.map(leg => `/${leg.toString()}`).join('').substring(1);
    return stringArray;
  }

  getModifierNickName(): string | undefined {
    const modifierNickName: { [key: string]: string } = {};
    const modifierEnum: { [key: string]: string } = {};
    return typeof this.Modifier === 'number'
        ? modifierNickName[modifierEnum[this.Modifier]]
        : modifierNickName[this.Modifier];
  }

  getError(
    event: any,
    race: any,
    pool: any,
    runners: any[],
    isBlockJurisdiction: boolean,
    isBlockJurisdictionMsg: string
  ): number {
    if (isBlockJurisdiction) {
      this.Error = isBlockJurisdictionMsg;
      return -1;
    }

    if (!event) {
      this.Error = 'Event Not Available';
      return -1;
    }

    if (!race) {
      this.Error = 'Race Not Available';
      return -1;
    }

    if (race.RaceStatus === 'Final') {
      this.Error = 'The Race Is Closed';
      return -1;
    }

    if (race.RaceStatus !== 0) {
      this.Error = `Race ${race.RaceId} - No wagering permitted`;
      return -1;
    }

    if (!pool) {
      this.Error = 'Pool not available';
      return -1;
    }

    if (this.Modifier) {
      let modifier = this.Modifier.toLowerCase();
      let isModifierAllowed: any;
      Object.entries(pool).forEach(([key, value]) => {
        if (key.toLowerCase() === modifier) {
          modifier = key;
          isModifierAllowed = value;
        }
      });
      this.Modifier = modifier;
      if (!isModifierAllowed) {
        this.Error = `${this.Modifier} not allowed`;
        return -1;
      }
    }

    if (runners.length === 0) {
      this.Error = 'No Runners are selected';
      return -1;
    }

    for (const runner of runners) {
      if (runner?.Scratched) {
        this.Error = `Runner ${runner.RunnerId} is scratched`;
        return -1;
      }
    }

    if (this.calcAmount() <= 0) {
      this.Error = 'No valid wager possible';
      return -1;
    }

    let minimumBet;
    // let maximum;
    if (this.calcAmount() > this.BaseAmount) {
      minimumBet = pool.MultipleBetMinimum;
      // maximum = Math.max(this.MaxWagerTotal, pool.WBMaximum);
    }
    else {
      minimumBet = pool.SingleBetMinimum;
      // maximum = Math.max(this.MaxWagerTotal, pool.Maximum);
    }

    if (this.BaseAmount < minimumBet) {
      this.Error = `Amount ${this.BaseAmount} less than minimum of ${minimumBet}`;
      return -1;
    }

    if (this.calcAmount() < pool.WagerMinimum) {
      this.Error = `Total ${this.calcAmount()} less than minimum total of ${pool.WagerMinimum}`;
      return -1;
    }

    // maximum
    if (this.calcAmount() > this.MaxWagerTotal) {
      this.Error = `Total ${this.calcAmount()} over the maximum total of ${this.MaxWagerTotal}`;
      return -1;
    }

    // if (this.calcAmount() > this.Maximum) {
    //   this.Error = `Total ${this.calcAmount()} greater than maximum wager of ${this.Maximum}`;
    //   return -1;
    // }

    if (pool.Multiple) {
      let tempBaseAmount = this.BaseAmount;
      let tempMinimumBet = minimumBet;
      if (minimumBet || this.BaseAmount < 1) {
        tempBaseAmount *= 10;
        tempMinimumBet *= 10;
      }
      if (tempBaseAmount % tempMinimumBet !== 0) {
        this.Error = `Wager ${this.BaseAmount} must be a multiple of ${minimumBet}`;
        return -1;
      }
    }

    return 0;
  }

  private setError(errorMessage: string): number {
    this.Error = errorMessage;
    return -1;
  }
}
